import { connect } from 'react-redux';

import { settingAction } from '../actions/settingAction';
import { appActions } from '../actions/appAction';
import { Setting } from '../components/Setting';
import { User, Catalog, Field } from '../states/settingState';
import { AdditionUser } from '../components/Setting';

export interface SettingActions {
    setLoading: (loading: boolean) => void;
    getUserAsync: (accountId: string, idid: string, role: string, start: number, size: number) => void;
    putUserAsync: (accountId: string, role: string, start: number, size: number, item: User, id: string) => void;
    postUsersAsync: (accountId: string, idid: string, role: string, start: number, size: number, id: string, postUsers: AdditionUser[]) => void;
    deleteUserAsync: (accountId: string, start: number, size: number, id: string, userId: string) => void;
    setCompleteUsersAddtion: (completeUsersAddtion: boolean) => void;
    postUserGroupsAsync: (accountId: string, idid: string, id: string, fileName: string) => void;
    postCatalogAsync: (accountId: string, idid: string, id: string, fileName: string) => void;
    postFieldAsync: (accountId: string, idid: string, id: string, fileName: string) => void;
    getUserGroupsStateAsync: (accountId: string, idid: string) => void;
    getCatalogStateAsync: (accountId: string, idid: string) => void;
    getCatalogAsync: (accountId: string, idid: string) => void;
    getCatalog: (catalogs: Catalog[]) => void;
    setMaxCatalogId: (id: number) => void;
    getFieldStateAsync: (accountId: string, idid: string) => void;
    getFieldAsync: (accountId: string, idid: string) => void;
    getField: (fields: Field[]) => void;
    setMaxFieldId: (id: number) => void;
    postActTypeAsync: (accountId: string, idid: string, id: string, fileName: string) => void;
    setCompleteActTypeAddtion: (completeUsersAddtion: boolean) => void;
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        setLoading: (loading: boolean) => dispatch(appActions.setLoading(loading)),
        getUserAsync: (accountId: string, idid: string, role: string, start: number, size: number) => dispatch(settingAction.getUserAsync(accountId, idid, role, start, size)),
        putUserAsync: (accountId: string, role: string, start: number, size: number, item: User, id: string) => dispatch(settingAction.putUserAsync(accountId, role, start, size, item, id)),
        postUsersAsync: (accountId: string, idid: string, role: string, start: number, size: number, id: string, postUsers: AdditionUser[]) => dispatch(settingAction.postUsersAsync(accountId, idid, role, start, size, id, postUsers)),
        deleteUserAsync: (accountId: string, start: number, size: number, id: string, userId: string) => dispatch(settingAction.deleteUserAsync(accountId, start, size, id, userId)),
        setCompleteUsersAddtion: (completeUsersAddtion: boolean) => dispatch(settingAction.setCompleteUsersAddtion(completeUsersAddtion)),
        postUserGroupsAsync: (accountId: string, idid: string, id: string, fileName: string) => dispatch(settingAction.postUserGroupsAsync(accountId, idid, id, fileName)),
        postCatalogAsync: (accountId: string, idid: string, id: string, fileName: string) => dispatch(settingAction.postCatalogAsync(accountId, idid, id, fileName)),
        postFieldAsync: (accountId: string, idid: string, id: string, fileName: string) => dispatch(settingAction.postFieldAsync(accountId, idid, id, fileName)),
        getUserGroupsStateAsync: (accountId: string, idid: string) => dispatch(settingAction.getUserGroupsStateAsync(accountId, idid)),
        getCatalogStateAsync: (accountId: string, idid: string) => dispatch(settingAction.getCatalogStateAsync(accountId, idid)),
        getCatalogAsync: (accountId: string, idid: string) => dispatch(settingAction.getCatalogAsync(accountId, idid)),
        getCatalog: (catalogs: Catalog[]) => dispatch(settingAction.getCatalog(catalogs)),
        setMaxCatalogId: (id: number) => dispatch(settingAction.setMaxCatalogId(id)),
        getFieldStateAsync: (accountId: string, idid: string) => dispatch(settingAction.getFieldStateAsync(accountId, idid)),
        getFieldAsync: (accountId: string, idid: string) => dispatch(settingAction.getFieldAsync(accountId, idid)),
        getField: (fields: Field[]) => dispatch(settingAction.getField(fields)),
        setMaxFieldId: (id: number) => dispatch(settingAction.setMaxFieldId(id)),
        postActTypeAsync: (accountId: string, idid: string, id: string, fileName: string) => dispatch(settingAction.postActTypeAsync(accountId, idid, id, fileName)),
        setCompleteActTypeAddtion: (completeUsersAddtion: boolean) => dispatch(settingAction.setCompleteActTypeAddtion(completeUsersAddtion)),
    };
};

const mapStateToProps = (state, ownProps) => {
    return Object.assign({}, state.settingsState, state.appState);
};

export default connect(mapStateToProps, mapDispatchToProps)(Setting);
